import { Box, Flex } from '@chakra-ui/react';
import bg from '../../../assets/image/home/bg.png';

const NewHomeBanner = () => {
  return (
    <Box
      color="white"
      textAlign="center"
      height="calc(100dvh - 65px)"
      position="relative"
      bgImage={`url(${bg})`}
      bgSize="cover"
      bgPosition="center">
      <Flex
        w="full"
        px="10px"
        position="absolute"
        top={{ base: '10%', md: '70px' }}
        left="50%"
        transform="translateX(-50%)"
        flexDir="column"
        alignItems="center">
        <Box
          fontFamily="Georgia"
          fontSize={{ base: 40, md: 88 }}
          fontWeight={600}
          lineHeight={{ base: '40px', md: '66px' }}
          textTransform="uppercase">
          AlloyX
        </Box>
        <Box
          fontFamily="Georgia"
          fontSize={{ base: 15, sm: 19, md: 30, lg: 40, xl: 44 }}
          fontWeight={600}
          lineHeight={{ base: '44px', md: '66px' }}
          textTransform="uppercase"
          mt="21px"
          mb="11px">
          AI-Driven Cross-Chain Trading Layer
          <br />
          The Cross-Chain Perp DEX
        </Box>
        <Box fontSize={{ base: 14, md: 20 }} lineHeight={{ base: '20px', md: '32px' }}>
          Trade Everything. Own Everything. Fully On-Chain.
        </Box>
      </Flex>
    </Box>
  );
};

export default NewHomeBanner;
